import { render, staticRenderFns } from "./DashboardBanner.vue?vue&type=template&id=12c3c07f&scoped=true&"
import script from "./DashboardBanner.vue?vue&type=script&lang=ts&"
export * from "./DashboardBanner.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBanner.vue?vue&type=style&index=0&id=12c3c07f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3c07f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VContainer,VRow})
